export type Theme = "light" | "dark";

export const THEME_STORAGE_KEY = "vpscope-theme";

export function themeForLocalHour(hour: number): Theme {
  return hour >= 19 || hour < 7 ? "dark" : "light";
}

export function automaticTheme(now = new Date()): Theme {
  return themeForLocalHour(now.getHours());
}

export function millisecondsUntilThemeBoundary(now = new Date()): number {
  const next = new Date(now);
  if (now.getHours() < 7) {
    next.setHours(7, 0, 0, 0);
  } else if (now.getHours() < 19) {
    next.setHours(19, 0, 0, 0);
  } else {
    next.setDate(next.getDate() + 1);
    next.setHours(7, 0, 0, 0);
  }
  return Math.max(1, next.getTime() - now.getTime());
}

export function savedTheme(storage: Pick<Storage, "getItem"> = localStorage): Theme | null {
  try {
    const value = storage.getItem(THEME_STORAGE_KEY);
    return value === "light" || value === "dark" ? value : null;
  } catch {
    return null;
  }
}

export function setDocumentTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute("content", theme === "dark" ? "#14171a" : "#f4f7f6");
}
